<template>
    <v-card flat style="background-color: transparent">

        <ProjectStepDetails
            v-model="isEditingItem"
            :item="editedItem"
            @save="updateStep"
        />
        <ProjectTaskDetails
            :item="editedTask"
            :moduleData="selectedModuleData"
            @save="updateTask"
            v-model="isEditingTask"
        />

        <v-card-text class="py-0">
            <div class="d-flex d-block mx-1 mb-4 pb-2 align-center justify-end">
                <div class="d-flex d-inline">
                    <v-btn 
                        v-if="moduleID && projectSteps"
                        color="info" 
                        class="my-2 ml-3 d-block"
                        title="Create a new step"
                        @click="createStep">
                        New Milestone
                    </v-btn>  
                    <!-- <v-btn 
                        v-if="selected && noProjectTemplate"
                        color="info" 
                        class="my-2 ml-3 d-block"
                        title="Create a new template"
                        @click="createTemplate">
                        Create New Template
                    </v-btn> -->
                    <v-btn 
                        v-if="moduleID && projectSteps"
                        :color="changeButtonColor ? 'error' : 'info'" 
                        class="my-2 ml-3 d-block"
                        title="Save the template"
                        @click="saveTemplate">
                        Save
                    </v-btn>               
                </div>
            </div>
            <div
                v-if="selectedProjectTemplate 
                    && selectedProjectTemplate.noProjectTemplate"
                class="empty-state mt-12"
            >
                <h2>No Template Found</h2>
                <p>Reach out to the administrator to create a template for this module.</p>
            </div>

            <v-data-table
                v-if="moduleID && projectSteps"
                :items="projectSteps"
                :headers="listHeaders"
                disable-sort
                :items-per-page="-1"
                hide-default-footer
                item-key="name"
                show-expand
            >
                <template v-slot:item="{ item, expand, isExpanded, index }">
                    <tr>
                        <td>
                            <v-btn icon @click="expand(!isExpanded)">
                            <v-icon>{{ isExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon
                            >
                            </v-btn>
                        </td>
                        <td class="psr_avenir_book">
                            <v-icon
                                class="mr-2"
                                :disabled="index === 0"
                                title="Move up"
                                @click="setStepIndex(item, index-1)"
                            >
                                mdi-arrow-up
                            </v-icon>
                            <v-icon
                                class="mr-2"
                                :disabled="index >= projectSteps.length - 1"
                                title="Move down"
                                @click="setStepIndex(item, index+1)"
                            >
                                mdi-arrow-down
                            </v-icon>
                        </td>
                        <td class="psr_avenir_book">{{ item.label }}</td>                                                                       
                        <td>
                            <v-icon
                                class="mr-2"
                                title="Edit step"
                                @click="editStep(item)"
                            >
                                mdi-pencil
                            </v-icon>
                            <v-icon
                                class="mr-2"
                                title="Create a new task"
                                @click="createTask(item)"
                            >
                                mdi-plus-box
                            </v-icon>

                            <v-icon
                                :color="item.tasks.length > 0 ? 'grey lighten-1' : 'grey'"
                                text
                                @click="confirmDeleteMilestone(item)">
                                mdi-delete
                            </v-icon>
                        </td>
                    </tr>
                </template>
                <template v-slot:expanded-item="{ headers, item }">
                    <tr
                        :colspan="headers.length"
                    >
                        <td :colspan="headers.length" class="primary darken-1">
                            <v-data-table
                                v-if="moduleID"
                                :items="item.tasks"
                                :headers="taskHeaders"
                                disable-sort
                                :items-per-page="-1"
                                hide-default-footer
                                item-key="name"
                                :header-props="{ class: 'primary darken-1 white--text' }"
                            >
                                <template v-slot:item="{ item: task, index }">
                                    <tr>
                                        <td class="psr_avenir_book"></td>
                                        <td>
                                            <v-icon
                                                class="mr-2"
                                                title="Move up"
                                                @click="setTaskIndex(item, task, index-1)"
                                                :disabled="index === 0"
                                            >
                                                mdi-arrow-up
                                            </v-icon>
                                            <v-icon
                                                class="mr-2"
                                                title="Move down"
                                                @click="setTaskIndex(item, task, index+1)"
                                                :disabled="index >= item.tasks.length - 1"
                                            >
                                                mdi-arrow-down
                                            </v-icon>
                                        </td>
                                        <td class="psr_avenir_book" v-html="task.label"></td>  
                                        <td class="psr_avenir_book text-center">{{ responsibleParties[task.responsible_party] }}</td>  
                                        <td class="psr_avenir_book">{{ ownerNames[task.owner_id] }}</td>  
                                        <td class="psr_avenir_book">{{ priorityItems[task.priority] }}</td>
                                        <td class="psr_avenir_book text-center">{{ complexityItems[task.complexity] }}</td>
                                        <td class="psr_avenir_book text-center">{{ durationItems[task.duration] }}</td>                                                                     
                                        <td class="psr_avenir_book text-center">
                                            <v-icon 
                                                :color="task.internal ? 'primary' : 'error'"
                                                :title="task.internal ? 'Internal Only' : 'External'">
                                                {{ task.internal ? 'mdi-check' : 'mdi-close' }}
                                            </v-icon>
                                        </td>
                                        <td>
                                            <v-icon
                                                class="mr-2"
                                                title="Edit task"
                                                @click="editTask(item, task)"
                                            >
                                                mdi-pencil
                                            </v-icon>
                                            <v-icon
                                                class="mr-2"
                                                title="Delete task"
                                                @click="deleteTask(item, task)"
                                            >
                                                mdi-delete
                                            </v-icon>
                                        </td>
                                    </tr>
                                </template>
                            </v-data-table>
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </v-card-text>
    </v-card>
</template>

<script>
    import axios from 'axios';
    import Cookie from 'js-cookie';
    import appUrls from '../../helpers/environment';
    import draggable from "vuedraggable";
    import ProjectStepDetails from './ProjectStepDetails.vue';
    import ProjectTaskDetails from './ProjectTaskDetails.vue';
    import { responsiblePartyItems, ownerItems, taskTypes, durationItems, priorityItems, complexityItems } from '../../helpers/constants';

    export default {
        name: 'ProjectTemplates',

        props: {
            moduleID: String,
            changeButtonColor: Boolean,
            showWarningToSave: Boolean,
            refreshModuleTemplate: Boolean
        },

        components: {
            draggable,
            ProjectStepDetails,
            ProjectTaskDetails
        },

        computed: {
            // Format modules for select list
            moduleList: function () {
                return this.modules.map((module) => ({
                    text: module.module_name,
                    value: module.module_id,
                    id: module.module_id
                }));
            },
            // Cache modules by ID for easy access
            moduleMap: function () {
                return this.modules.reduce((acc, module) => {
                    acc[module.module_id] = module;
                    return acc;
                }, {});
            },
            projectSteps: {
                get: function () {
                    return this.selectedProjectTemplate 
                        && this.selectedProjectTemplate.project_template 
                        && this.selectedProjectTemplate.project_template.projectSteps;
                },
                set: function (value) {
                    this.selectedProjectTemplate.project_template.projectSteps = [...value];
                }
            },
            // Currently selected module data
            selectedModuleData: function () {
                return this.moduleMap[this.moduleID];
            },
            stepTasks: {
                get: function () {
                    return this.projectSteps && this.projectSteps.tasks;
                },
                set: function (value) {
                    this.projectSteps = {...this.projectSteps, tasks: [...value]};
                }
            }
        },
        
        data: () => {
            const taskHeaderDefaults = { class: 'primary darken-1 white--text'};

            return {
                noProjectTemplate: false,
                modules: [],
                editedItem: {},
                editedTask: {},
                isEditingItem: false,
                isEditingTask: false,
                projectTemplateCache: {},
                selectedProjectTemplate: null,
                listHeaders: [
                    { text: 'Order', width: '100px' },
                    { text: 'Label',  value: 'label',    align: 'start'},
                    { text: 'Actions',     width: '200px', value: 'actions',    align: 'start'}
                ],
                taskHeaders: [
                    { ...taskHeaderDefaults, text: '', width: '52px' },
                    { ...taskHeaderDefaults, text: 'Order', width: '100px' },
                    { ...taskHeaderDefaults, text: 'Label',  value: 'label',    align: 'start'},
                    { ...taskHeaderDefaults, text: 'Responsibility', value: 'responsible_party', align: 'center'},
                    { ...taskHeaderDefaults, text: 'Owner', value: 'owner_id', align: 'start'},
                    { ...taskHeaderDefaults, text: 'Priority', value: 'priority', align: 'start'},
                    { ...taskHeaderDefaults, text: 'Complexity', value: 'complexity', align: 'center'},
                    { ...taskHeaderDefaults, text: 'Duration', value: 'duration', align: 'center'},
                    { ...taskHeaderDefaults, text: 'Internal Only', value: 'internal', align: 'center'},
                    { ...taskHeaderDefaults, text: 'Actions',     width: '186px', value: 'actions',    align: 'start'}
                ],
                responsibleParties: responsiblePartyItems,
                ownerNames: ownerItems,
                priorityItems: priorityItems,
                complexityItems: complexityItems,
                taskTypes: taskTypes,
                durationItems: durationItems
            }
        },

        created () {
            this.provisionProjectTemplate();
        },

        methods: {
            forceTaskRefresh: function (parentStep) {
                parentStep.tasks = [...parentStep.tasks];
            },

            updateStep: async function (item) {
                const {isNew} = item;
                const projectStepsCopy = [...this.projectSteps];

                if (isNew) {
                    delete item.isNew;
                    projectStepsCopy.push(item);
                } else {
                    const currentIndex = projectStepsCopy.findIndex((step) => step.name === item.name);
                    projectStepsCopy[currentIndex] = item;
                }

                this.$emit('showWarningToSave', true)
                this.projectSteps = projectStepsCopy;
            },

            updateTask: async function (task) {
                // console.log('task: ', task)
                const {parent, isNew} = task;
                const parentStep = this.getStepByName(parent);

                if (isNew) {
                    delete task.isNew;
                    parentStep.tasks.push(task);
                } else {
                    const index = parentStep.tasks.findIndex((t) => t.name === task.name);
                    parentStep.tasks[index] = task;
                }

                this.$emit('showWarningToSave', true)
                this.forceTaskRefresh(parentStep);
            },

            getStepByName: function (name) {
                return this.projectSteps.find((step) => step.name === name);
            },

            provisionProjectTemplate: async function () {
                const module_id = this.moduleID;

                if (!this.projectTemplateCache[module_id]) {
                    // Template is not cached. Fetch it and cache.
                    try {
                        const projectTemplate = await axios.get(`${appUrls.api}/api/project_template/${module_id}`, {
                            headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
                        });

                        this.projectTemplateCache[module_id] = projectTemplate.data;
                        // console.log(this.projectTemplateCache[module_id])

                    } catch ( error ) {
                        if (error.response && error.response.status === 404) {
                            this.projectTemplateCache[module_id] = {
                                noProjectTemplate: true
                            };
                        }
                    };
                }

                // Return from cache
                this.selectedProjectTemplate = await this.projectTemplateCache[module_id];
            },

            saveTemplate: async function () {
                try {
                    // console.log(this.selectedProjectTemplate)
                    const projectTemplate = this.selectedProjectTemplate;

                    const saveTemplate = await axios.put(`${appUrls.api}/api/project_template/${this.selectedProjectTemplate.project_template_id}`, projectTemplate, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                    });

                    const status = saveTemplate.status;
                    if (status === 200) {
                        this.$emit('triggerUserFeedback', true, 'Project Templates Saved');
                    } else {
                        this.$emit('triggerUserFeedback', true, 'There was a problem saving the Project Template', 'error');
                    }

                    this.$emit('showWarningToSave', false)
                    this.$emit('changeButtonColor', false)
                    
                } catch ( error ) {
                    console.log(error);
                };
            },

            confirmDeleteMilestone(item) {
                if (item.tasks.length > 0) {
                    this.$emit('triggerUserFeedback', true, 'All tasks belonging to this milestone must be deleted before deleting it!', 'error');
                } else {
                    const confirmed = window.confirm("Are you sure you want to delete this milestone?");
                    if (confirmed) {
                        const index = this.projectSteps.findIndex((step) => step.name === item.name);
                        this.projectSteps.splice(index, 1);
                        
                        this.$emit('showWarningToSave', true);
                        this.$emit('changeButtonColor', true);
                    }
                }
            },

            createStep() {
                if ( this.showWarningToSave ) {
                    this.$emit('triggerUserFeedback', true, 'Please save the template before creating a new milestone', 'error');
                    return;
                }
                this.editStep({
                    isNew: true,
                    tasks: []
                });
            },

            createTask(parent) {
                // console.log(parent)
                const newTask =  {
                    isNew: true,
                    label: '',
                    email_template: '',
                    task_type: 'general'
                };

                this.editTask(parent, newTask);
            },

            editStep(item) {
                this.editedItem = {...item};
                this.isEditingItem = true;
            },

            editTask(parent, item) {
                // console.log(item)
                this.editedTask = {
                    ...item,
                    parent: parent.name
                };
                this.isEditingTask = true;
            },

            setStepIndex(item, newIndex) {
                const projectStepsCopy = [...this.projectSteps];
                const currentIndex = projectStepsCopy.findIndex((step) => step.name === item.name);
                const newIndexValue = projectStepsCopy[newIndex];

                projectStepsCopy[newIndex] = item;
                projectStepsCopy[currentIndex] = newIndexValue;
                
                this.projectSteps = projectStepsCopy;

                this.$emit('showWarningToSave', true);
                this.$emit('changeButtonColor', true);
            },

            setTaskIndex(parentStep, item, newIndex) {
                const currentIndex = parentStep.tasks.findIndex((task) => task.name === item.name);
                const newIndexValue = parentStep.tasks[newIndex];

                parentStep.tasks[newIndex] = item;
                parentStep.tasks[currentIndex] = newIndexValue;

                this.forceTaskRefresh(parentStep);

                this.$emit('showWarningToSave', true);
                this.$emit('changeButtonColor', true);
            },

            deleteTask(parentStep, task) {
                const confirmed = window.confirm("Are you sure you want to delete this task?");
                if (confirmed) {
                    const index = parentStep.tasks.findIndex((t) => t.name === task.name);
                    parentStep.tasks.splice(index, 1);

                    this.forceTaskRefresh(parentStep);

                    this.$emit('showWarningToSave', true);
                    this.$emit('changeButtonColor', true);
                }
            }
        },

        watch: {
            moduleID: async function (val) {
                if (val) {
                    await this.provisionProjectTemplate();
                }
            },

            refreshModuleTemplate: async function (val) {
                if (val) {
                    await this.provisionProjectTemplate();
                }
            }
        }
    }
</script>

<style scoped>
    div.listings:nth-of-type(even) {
        /* background-color: #eef7f8; */
        padding: 2px 0;
    }
    .draggable-icon {
        cursor: move;
    }
    .empty-state {
        text-align: center;
        margin-top: 20px;
    }
    h2, h3, p {
        margin: 2rem 0;
    }
</style>


// WEBPACK FOOTER //
// src/components/datamanagement/ProjectTemplates.vue